export var animationVariants = {
  fade: {
    duration: ".3s",
    delay: ".3s",
    function: "ease-in-out"
  },
  slide: {
    text: "#004085",
    bg: "#cce5ff",
    border: ""
  }
};